import { useMemo } from 'react';
import { AppState } from '../../types';
import { getOrCreateSnapLines } from '../../helpers/guidelines';
import { worldPx } from '../../helpers/handleScale';
import { getSnapMetrics } from '../../helpers/snapScale';
import { DEBUG_SNAPLINE_STROKE_WIDTH_PX } from '../../helpers/snapTokens';

type DebugSnaplinesProps = {
  elements: AppState['elements'];
  scale: number;
};

const DEBUG_COLOR = 'var(--active-blue)';
const DEBUG_OPACITY = 0.32;

export const DebugSnaplines = (props: DebugSnaplinesProps) => {
  const { elements, scale } = props;
  const scaledStrokeWidth = worldPx(DEBUG_SNAPLINE_STROKE_WIDTH_PX, scale);

  const { snapLines } = useMemo(
    () => getOrCreateSnapLines(getSnapMetrics(scale), elements),
    [elements, scale]
  );

  return (
    <g className="debug-snap-lines" pointerEvents="none">
      {snapLines.map((snapLine, index) => (
        <line
          key={`debug-line-${index}`}
          x1={snapLine.extended.start.x}
          y1={snapLine.extended.start.y}
          x2={snapLine.extended.end.x}
          y2={snapLine.extended.end.y}
          stroke={DEBUG_COLOR}
          strokeOpacity={DEBUG_OPACITY}
          strokeWidth={scaledStrokeWidth}
          strokeDasharray={2}
        />
      ))}
    </g>
  );
};
